exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-blocked{position:fixed;top:0;left:0;width:100%;height:100%;background:#fff;text-align:center;padding:10px;z-index:1000}.site-blocked p{color:#000!important}", ""]);

// exports
